module.exports = __webpack_public_path__ + "static/media/gov_canada.8c1f4c77.svg";